import {
  TransferPayment,
  TransferPaymentInput
} from '../../lib/types/models/transfer/transfer-payments'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateTransferPayment(
  input: TransferPaymentInput & { id: number; transferId: number }
) {
  const { id, transferId, ...data } = input
  return restApiClient
    .url(constructApiUrl(API.transfer.updatePayment.url, { id, transferId }))
    .patch<TransferPayment, TransferPaymentInput>(data)
}
